import { render, staticRenderFns } from "./message_history_table.vue?vue&type=template&id=193e765b&scoped=true"
import script from "./message_history_table.vue?vue&type=script&lang=ts"
export * from "./message_history_table.vue?vue&type=script&lang=ts"
import style0 from "./message_history_table.vue?vue&type=style&index=0&id=193e765b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193e765b",
  null
  
)

export default component.exports